module.exports = __webpack_public_path__ + "static/media/körsbär-min.40f5350d.png";